import React from 'react';
import { Box, Stack } from '@mui/material';
import IncidentAlerts from './components/Alerts/IncidentAlerts';
import ChartModal from './components/Chart/ChartModal';
import IncidentDataGrid from './components/DataGrid/IncidentDataGrid';
import HeaderSection from './components/HeaderSection/HeaderSection';
import HelpButton from './components/HelpButton/HelpButton';
import LoadingState from './components/LoadingState/LoadingState';
import { ChartModalProvider } from './hooks/useChartModalState';
import { useConnectionStatus } from './hooks/useConnectionStatus';
import { useIncidentColumns } from './hooks/useIncidentColumns';
import { useMaxCellTMonitor } from './hooks/useMaxCellTMonitor';
import { SPACING } from './styles';
import type { IncidentMaxCellTMonitorProps } from './types';

const COMPONENT_NAME = 'IncidentMaxCellTMonitor';

const IncidentMaxCellTMonitor: React.FC<IncidentMaxCellTMonitorProps> = (
  props,
) => {
  const { siteMeta, timeMode } = props;

  const { incidents, loading, lastDataUpdate } = useMaxCellTMonitor(props);

  const connectionStatus = useConnectionStatus();
  const columns = useIncidentColumns(timeMode, siteMeta);

  if (loading) {
    return <LoadingState />;
  }

  return (
    <ChartModalProvider>
      <Box sx={{ width: '100%', height: '100%', position: 'relative' }}>
        <HelpButton />

        <HeaderSection
          connectionStatus={connectionStatus}
          lastDataUpdate={lastDataUpdate}
          timeMode={timeMode}
          siteMeta={siteMeta}
        />

        <Stack spacing={SPACING.MEDIUM}>
          <IncidentAlerts incidents={incidents} />

          {incidents.length > 0 && (
            <IncidentDataGrid incidents={incidents} columns={columns} />
          )}
        </Stack>
      </Box>

      <ChartModal />
    </ChartModalProvider>
  );
};

IncidentMaxCellTMonitor.displayName = COMPONENT_NAME;

export default IncidentMaxCellTMonitor;
